module.exports = __webpack_public_path__ + "static/media/logo.c0b171f2.png";